


const baseGeneralUrl = "General"
  const endpoints = {
   getCountries:`${baseGeneralUrl}/Countries`,
   getStateProvinces:`${baseGeneralUrl}/Cities`,
   getDistricts:`${baseGeneralUrl}/Districts`,
   getCities:`${baseGeneralUrl}/Neighbourhoods`,
   getNeighbourhoodsByDistrictIds:`${baseGeneralUrl}/NeighbourhoodsByDistrictIds`
  };
  
  export default endpoints;
  



